export interface AppPaths {
  dashboard: string;
  conversations: string;
  notifications: string;
  analytics: string;
  integrations: string;
  customers: string;
  assistant: string;
}

export const paths: AppPaths = {
  dashboard: "/",
  conversations: "/conversations",
  notifications: "/notifications",
  analytics: "/analytics",
  integrations: "/integrations",
  customers: "/customers",
  assistant: "/assistant",
};
